import Phaser from "phaser";
// import { ExampleScene } from "./scenes/ExampleScene";
import { HomeScene } from "@phaser/scenes/HomeScene";
import { GameScene } from "@phaser/scenes/GameScene";
import { GameOverScene } from "@phaser/scenes/GameOverScene";
import { ShopScene } from "@phaser/scenes/ShopScene";
import { CodexScene } from "@phaser/scenes/CodexScene";
import { LoadingScene } from "./scenes/LoadingScene";

export class Game extends Phaser.Game {
  public appEvents = new Phaser.Events.EventEmitter();

  constructor(parentElement: HTMLElement) {
    const config: Phaser.Types.Core.GameConfig = {
      type: Phaser.AUTO,
      parent: parentElement,
      width: 768,
      height: 1366,
      backgroundColor: "000000",
      scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
      },
      input: {
        activePointers: 3,
      },
      scene: [
        LoadingScene,
        HomeScene,
        GameScene,
        GameOverScene,
        ShopScene,
        CodexScene,
      ],
    };

    super(config);
  }
}

export const APP_EVENTS = {
  BACKGROUND: "APP_BACKGROUND",
  FOREGROUND: "APP_FOREGROUND",
} as const;
